'use strict';
DoohApps
    .directive('validateDomain', ['User', function (User) {
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function (scope, elm, attrs, ctrl) {
                if (ctrl && User.company.domain) {
                    ctrl.$validators.domain = function (modelValue) {
                        return ctrl.$isEmpty(modelValue) || modelValue.replace(/.*@/, '').toUpperCase() === User.company.domain.toUpperCase();
                    };
                }
            }
        };
    }]);